import { render, staticRenderFns } from "./SummaryLab.vue?vue&type=template&id=710aa1b2"
import script from "./SummaryLab.vue?vue&type=script&lang=js"
export * from "./SummaryLab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports